import React, { Suspense, useCallback, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import Page from '../Page';
//import ProfileForm from 'forms/forms/ProfileForm';
//import PasswordForm from 'forms/forms/PasswordForm'
import Loader from 'components/Loader';
import Icon from 'components/Icon';
import Text from 'components/Text';

import './index.sass';
// import { useLazyQuery } from '../../../utils/useQuery';
// import { GET_USER_BY_PHONE_IF_AUTHENTICATED } from 'api/users';
// import { formatDateFromPythonToDots } from 'utils/format';
import { Button, IconButton } from 'components/Button';
import Model from '../../../model';
import { formatNumber } from 'utils/format';
import { getPointSuffix } from 'utils/plurals-declination';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { birthdayFormatFromUTC, datetimeFromUTC } from 'utils/dayjs';
import ChangePasswordFormModal from 'forms/forms/ChangePasswordForm/Modal';
import ProfileForm from 'forms/forms/ProfileForm';
import profileForm from 'forms/forms/ProfileForm';
import { Skeleton } from '@mui/material';
import { useNavigate } from 'react-router';
import { useMobile } from 'utils/media';
//import CertificateForm from 'forms/forms/CertificateForm';
//import BalanceForm from 'forms/forms/BalanceForm';

const { block, el } = bem('profile');

const Profile = () => {

     const { userData } = Model.user;

    return (
        <div className={ block() }>
            <Suspense fallback={<UserBlockSkeleton />}>
                <UserBlock resource={userData} />
            </Suspense>
        </div>
    );
};

const UserBlock = ({resource}) => {
    const user = resource.read();
    const {
        firstName,
        lastName,
        birthday,
        email,
        skype,
        sex,
        ask,
        balance,
        username
    } = user;

    const pointSuffix = getPointSuffix(balance);

    const [ isEditMode, setEditMode ] = useState(false);
    const [ formHeight, setFormHeight ] = useState('auto');
    const [ userBlockHeight, setUserBlockHeight ] = useState('auto');
    const { openChangePasswordForm, openUpdateBalanceForm } = Model.modal;
    const { isKZ } = Model.kz;
    const navigate = useNavigate();

    const defaultValues = {
        firstName,
        lastName,
        birthday,
        email,
        skype,
        sex,
        ask
    }

    const turnOnEditMode = () => {
        setEditMode(true);
    }

    const turnOffEditMode = () => {
        setEditMode(false);
    }

    const profileFormRef = useCallback(node => {
        if (node !== null) {
            setFormHeight(`${node.getBoundingClientRect().height}px`);
        }
    }, []);

    const userBlockRef = useCallback(node => {
        if (node !== null) {
            setUserBlockHeight(`${node.getBoundingClientRect().height}px`);
        }
    }, []);

    const replenishClickHandler = () => isKZ ? navigate('/foreign-payments') : openUpdateBalanceForm();

    return (
        <>
            <div className={ el('profile-block') } style={{height: isEditMode ? formHeight : userBlockHeight}}>
                <div className={ el('user-block') } ref={userBlockRef}>
                    <div className={ el('user-data-block') }>
                        <div className={ el('user-data', 'name') }>
                            <div className={ el('user-data-label') }>
                                <Text>Имя</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text>{ firstName || '-' }</Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Фамилия</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text>{ lastName || '-' }</Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Номер телефона</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text>{ formatPhoneNumberIntl(username) }</Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>E-mail</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text>{ email || '-' }</Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Пол</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text>{ sex === 'M' ? 'Мужской' : 'Женский' }</Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Дата рождения</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text>{ datetimeFromUTC(birthday, true).date || '-' }</Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Skype</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text>{ skype || '-' }</Text>
                            </div>
                        </div>
                        <div className={ el('user-data', 'ask') }>
                            <div className={ el('user-data-label') }>
                                <Text>Запрос к специалисту</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text>{ ask || '-' }</Text>
                            </div>
                        </div>
                    </div>
                    <div className={ el('user-data-buttons') }>
                        <div className={ el('user-data-button', 'edit') } onClick={ turnOnEditMode }>
                            <Icon name={ 'pencil' }/>
                            <Text serif>Редактировать</Text>
                        </div>
                        <div className={ el('user-data-button', 'password') } onClick={ openChangePasswordForm }>
                            <Icon name={ 'lock' }/>
                            <Text serif>Сменить пароль</Text>
                        </div>
                    </div>
                </div>
                <div className={ el('profile-form-block', { 'visible': isEditMode }) }>
                    <ProfileForm defaultValues={ defaultValues } turnOffEditMode={ turnOffEditMode } ref={profileFormRef}/>
                </div>
            </div>
            <div className={ el('balance-block') }>
                <div className={ el('balance-block-header') }>
                    <div className={ el('balance-block-label') }>
                        <Icon name={ 'wallet' }/>
                        <Text>Ваш баланс</Text>
                    </div>
                    {/*<div className={el('balance-block-history')}>*/ }
                    {/*    <Icon name={'clock'} />*/ }
                    {/*    <Text serif>История</Text>*/ }
                    {/*</div>*/ }
                </div>
                <div className={ el('balance-block-value') }>
                    <Text serif>{ `${ formatNumber(balance) } ${ pointSuffix }` }</Text>
                </div>
                <div className={ el('balance-block-buttons') }>
                    <IconButton name={ 'plus' } mod={ 'transparent-gold' } onClick={replenishClickHandler}>
                        <Text>Пополнить</Text>
                    </IconButton>
                </div>
            </div>
            <ChangePasswordFormModal/>
        </>
    )
}

const UserBlockSkeleton = () => {
    return (
        <>
            <div className={ el('profile-block') } >
                <div className={ el('user-block') } >
                    <div className={ el('user-data-block') }>
                        <div className={ el('user-data', 'name') }>
                            <div className={ el('user-data-label') }>
                                <Text>Имя</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text><Skeleton /></Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Фамилия</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text><Skeleton /></Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Номер телефона</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text><Skeleton /></Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>E-mail</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text><Skeleton /></Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Пол</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text><Skeleton /></Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Дата рождения</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text><Skeleton /></Text>
                            </div>
                        </div>
                        <div className={ el('user-data') }>
                            <div className={ el('user-data-label') }>
                                <Text>Skype</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text><Skeleton /></Text>
                            </div>
                        </div>
                        <div className={ el('user-data', 'ask') }>
                            <div className={ el('user-data-label') }>
                                <Text>Запрос к специалисту</Text>
                            </div>
                            <div className={ el('user-data-value') }>
                                <Text><Skeleton /></Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={ el('balance-block') }>
                <div className={ el('balance-block-header') }>
                    <div className={ el('balance-block-label') }>
                        <Icon name={ 'wallet' }/>
                        <Text>Ваш баланс</Text>
                    </div>
                    {/*<div className={el('balance-block-history')}>*/ }
                    {/*    <Icon name={'clock'} />*/ }
                    {/*    <Text serif>История</Text>*/ }
                    {/*</div>*/ }
                </div>
                <div className={ el('balance-block-value') }>
                    <Text serif><Skeleton /></Text>
                </div>
                <div className={ el('balance-block-buttons') }>
                    <Skeleton />
                </div>
            </div>
        </>
    )
}

export default observer(Profile);


